import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const SuspensionPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Suspensión de linea</PageTitle>
      <View />
    </>
  );
};

export { SuspensionPage };
